import { BaseTelegramGroup } from '@numeo/types-core'
import axios from 'axios'

class UserTelegramGroupApi {
    async updateTelegramGroup(userId: string, telegramGroup: BaseTelegramGroup | null): Promise<void> {
        await axios.put(`/users/${userId}/telegram-group`, {
            telegramGroup,
        })
    }
}

export const userTelegramGroupApi = new UserTelegramGroupApi()
